import branding from "../../branding/branding"
import { ProfileResponseStatus } from "./LoginSite"
import { CenterLoginStyleErrorMessage, ErrorMessagesContainer } from "./CenterLoginSharedComponents"
import { CreateNewTokenButton } from "./token/LoginWithToken"

interface LoginErrorProperties {
    profileResponseStatus: ProfileResponseStatus
    clickListener?: () => void
}

function LoginError(props: LoginErrorProperties) {
    const { profileResponseStatus } = props
    const localLogoutReason =
        localStorage.getItem("logoutReason") === null
            ? null
            : localStorage.getItem("logoutReason") === "logoutReasonSessionTimeout"
            ? branding.loginRegistrationSite.logoutReasonSessionTimeout
            : branding.loginRegistrationSite.logoutReasonForbidden

    const invalidEmail = branding.loginRegistrationSite.invalidEmailPanelWithLink.visible ? (
        <p>
            {branding.loginRegistrationSite.invalidEmailPanelWithLink.befLinkPart}
            <a
                className="invalid-email-link"
                href={branding.loginRegistrationSite.invalidEmailPanelWithLink.link}
                target="_blank"
                rel="noopener noreferrer"
            >
                {branding.loginRegistrationSite.invalidEmailPanelWithLink.text}
            </a>
            {branding.loginRegistrationSite.invalidEmailPanelWithLink.aftLinkPart}
        </p>
    ) : (
        <p>{branding.loginRegistrationSite.invalidEmailPanel}</p>
    )

    if (
        !localLogoutReason &&
        (profileResponseStatus === ProfileResponseStatus.SUCCESS || profileResponseStatus === ProfileResponseStatus.NONE)
    )
        return null

    return (
        <ErrorMessagesContainer>
            <CenterLoginStyleErrorMessage>
                {localLogoutReason && <p>{localLogoutReason}</p>}

                {profileResponseStatus === ProfileResponseStatus.FAILURE && (
                    <p>{branding.loginRegistrationSite.registerEmailFailed}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.FAILURE_EMAIL_INVALID && invalidEmail}

                {profileResponseStatus === ProfileResponseStatus.LOGIN_BLOCKED && (
                    <div>
                        <p>{branding.loginRegistrationSite.codeResendLimit}</p>
                        <CreateNewTokenButton
                            variant="link"
                            onClick={() => window.open(`${branding.loginRegistrationSite.contactSupportUrl}`, "_blank")}
                        >
                            {branding.loginRegistrationSite.contactSupportText}
                        </CreateNewTokenButton>
                    </div>
                )}

                {profileResponseStatus === ProfileResponseStatus.FAILURE_PRIVACY_DOCS_OUTDATED && (
                    <p>{branding.loginRegistrationSite.outdatedPrivacyDocsPanel}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.THIRD_PARTY_USER_NOT_FOUND && (
                    <p>{branding.loginRegistrationSite.thirdPartyUserNotFound}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.USER_CREATION_NOT_ALLOWED && (
                    <p>{branding.loginRegistrationSite.userCreationNotAllowed}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.WRONG_PASSWORD && (
                    <p>{branding.loginRegistrationSite.wrongPasswordPanel}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.TICKET_FAILURE && (
                    <p>{branding.loginRegistrationSite.ticketCodeFailureMessage}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.TICKET_CONFIGURATION_ISSUE && (
                    <p>{branding.loginRegistrationSite.ticketConfigurationIssueMessage}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.TICKET_NOT_VALID && (
                    <p>{branding.loginRegistrationSite.ticketNotValidMessage}</p>
                )}

                {profileResponseStatus === ProfileResponseStatus.TICKET_ALREADY_REDEEMED && (
                    <p>{branding.loginRegistrationSite.ticketAlreadyRedeemedMessage}</p>
                )}
            </CenterLoginStyleErrorMessage>
        </ErrorMessagesContainer>
    )
}

export default LoginError
